﻿import { ICookie } from "@models";
import * as ruleUtils from "@rules/rule-utils";

export class RestClient {
    constructor(private e: any) {
    }
    
    public defaultPortNum = 0; // If 0 then use 80 for http and 443 for https
    public basicAuthUser: string;
    public basicAuthPass: string;
    public baseUrl: string;
    public cookies: ICookie[] = [];

    protected processResponse = response => {
        if (response.cookies) {
            for (let key in response.cookies) {
                let existingCookie = this.cookies.find(c => c.name == key);
                if (existingCookie) this.cookies.remove(existingCookie);
                this.cookies.push({
                    name: key,
                    value: response.cookies[key]
                });
            }
        }
    }

    public makeCall(params: any) {
        if (this.cookies.length) {
            if (!params.headers) {
                params.headers = [];
            }

            params.headers.push({
                name: "Cookie",
                value: this.cookies.map(c => c.name + "=" + c.value).join("; ")
            });
        }

        if (!params.headers.find(h => h.name == "Connection")) {
            params.headers.push({
                name: "Connection",
                value: "keep-alive"
            });
        }

        params.headers.push({
            name: "User-Agent",
            value: "KBMax v3"
        });

        if (this.baseUrl) {
            params.url = this.baseUrl + params.url;
        }

        if (!params.headers.find(h => h.name == "Host")) {
            let l = ruleUtils.getLocation(params.url);
            if (l) {
                params.headers.push({
                    name: "Host",
                    value: l.hostname
                });
            }
        }

        let contentType = params.headers.find(h => h.name == "Content-Type");
        if (!contentType) {
            contentType = {
                name: "Content-Type",
                value: "application/text"
            };
            params.headers.push(contentType);
        }
        if (typeof params.body != "string") {
            if (contentType.value == "application/json") {
                params.body = JSON.stringify(params.body);
            }
            if (contentType.value == "application/x-www-form-urlencoded") {
                params.body = ruleUtils.toQueryString(params.body);
            }
        }

        params.headers.push({
            name: "Accept",
            value: contentType.value + ", text/plain, */*"
        });

        if (this.basicAuthUser && !params.authentication) {
            params.authentication = {
                username: this.basicAuthUser,
                password: this.basicAuthPass
            };
        }

        if (this.defaultPortNum && !params.port) {
            params.port = this.defaultPortNum;
        }

        return this.e.callRestService(params).then(restResponse => {
            this.processResponse(restResponse);
            return restResponse;
        });
    }
}
